"use client"
import React from "react"
import { white } from "../components/colors"
import { styled } from "styled-components"

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  cursor: pointer;
  font-weight: bold;
  @media (max-width: 791px) {
    flex-direction: column;
  }
`

const MainText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`

const SubText = styled.div``

const RadioItem = styled.div<{ $selected: boolean }>`
  color: ${white};
  background: ${props => (props.$selected ? white : "#142343")};
  color: ${props => (props.$selected ? "#26386b" : white)};
  flex-shrink: 0;
  padding: 0.3rem 0.5rem;
  border-color: ${white};
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0.2rem;
  border-bottom-width: 0.2rem;
  flex-grow: 1;
  &:first-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    border-left-width: 0.2rem;
    @media (max-width: 791px) {
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0rem;
      border-bottom-left-radius: 0rem;
      border-left-width: 0.2rem;
      border-right-width: 0.2rem;
      border-bottom-width: 0rem;
    }
  }
  &:last-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    border-right-width: 0.2rem;
    @media (max-width: 791px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
      border-left-width: 0.2rem;
      border-right-width: 0.2rem;
      border-bottom-width: 0.2rem;
      border-top-width: 0;
    }
  }
`

export type RadioButtonOption = {
  id: string
  main: string | React.ReactNode
  sub?: string
}

export const RadioButton: React.FC<{
  className?: string
  options: RadioButtonOption[]
  selected: string
  onSelect: (selectedOption: string) => void
}> = ({ options, selected, onSelect, className }) => {
  return (
    <RadioGroup className={className}>
      {options.map(option => (
        <RadioItem
          $selected={option.id === selected}
          onClick={() => onSelect(option.id)}
          key={`radio-${option.id}`}
        >
          <MainText>{option.main}</MainText>
          {option.sub && <SubText>{option.sub}</SubText>}
        </RadioItem>
      ))}
    </RadioGroup>
  )
}
